import { defineMessages } from "react-intl"

export const priceBreakdownMessages = defineMessages({
	categoryTotalPrice: {
		defaultMessage: "Total {categoryName}",
		id: "priceBreakdown.categoryTotalPrice",
	},
	genericError: {
		defaultMessage: "Something went wrong while calculating prices",
		id: "priceBreakdown.genericError",
	},
	hidePricing: {
		defaultMessage: "Hide pricing",
		id: "priceBreakdown.hidePricing",
	},
	showPricing: {
		defaultMessage: "Show pricing",
		id: "priceBreakdown.showPricing",
	},
	title: {
		defaultMessage: "Total Retail Price",
		id: "priceBreakdown.title",
	},
	totalPrice: {
		defaultMessage: "Total price",
		id: "priceBreakdown.totalPrice",
	},
})
